import React, { useEffect, useState } from "react";
import { formatDistance, parseISO } from "date-fns";
import { getActiveProgramById, getGroupSession } from "../../services/ActivePrograms";
import { IoArrowBack } from "react-icons/io5";
import { AiFillEdit } from "react-icons/ai";

import "react-quill/dist/quill.snow.css";

import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  BarChart,
  Bar,
} from "recharts";
import moment from "moment";
import { MdDownloadForOffline } from "react-icons/md";
import { PDFDownloadLink } from "@react-pdf/renderer";
import SessionNotePDF from "./SessionNotePDF";

const RateChart = ({ data }) => {
  return (
    <ResponsiveContainer width="100%" height={220}>
      <AreaChart
        data={data}
        margin={{
          top: 10,
          right: 0,
          left: -25,
          bottom: 0,
        }}
      >
        <CartesianGrid
          strokeDasharray="3 1"
          stroke="#999B9C"
          vertical={false}
          horizontal={true}
        />
        {/* <XAxis dataKey="name" /> */}
        <YAxis />
        <Tooltip
          formatter={(value, name, props) => [value, name]}
          labelFormatter={(label, payload) => {
            // Show name from payload[0].payload
            if (payload && payload.length) {
              return payload[0].payload.name; // Replace 'name' with your key
            }
            return label;
          }}
        />
        <Area
          type="monotone"
          dataKey="value"
          strokeWidth={3}
          stroke="#4CC2B0"
          fill="#4CC2B0"
          fillOpacity={0.3}
        />
        <Area
          type="monotone"
          dataKey="value2"
          strokeWidth={3}
          stroke="#999B9C"
          fill="#999B9C"
          fillOpacity={0.3}
        />
      </AreaChart>
    </ResponsiveContainer>
  );
};
const ConcernChart = ({ data }) => {
  const chartData = data.map((item, index) => ({
    name: String.fromCharCode(65 + index),
    Concern: parseInt(item.numberOfMembers),
  }));
  return (
    <ResponsiveContainer  height={220} width="100%">
      <BarChart height={250} data={chartData}>
        <CartesianGrid strokeDasharray="3" />
        <XAxis dataKey="name" />
        <YAxis />
        <Bar dataKey="Concern" fill="#1F7E78" />
      </BarChart>
    </ResponsiveContainer>
  );
};
function ViewSessionGroupNoteDetails({ setViewMode, state, member }) {
  const [session, setSession] = useState(null);
  const [chartImage, setChartImage] = useState(null);
  const [isLoading, setLoader] = useState(true);
  const [programDetails, setProgramDetails] = useState(null);

  const getSession = async () => {
    try {
      const res = await getGroupSession(
        state?._id,
        state?.programId,
      );
      console.log("group session",res?.data?.data);
      setSession(res?.data?.data);
      setLoader(false);
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };
  const getProgram = async () => {
    try {
      const res = await getActiveProgramById(state?.programId);
      setProgramDetails(res?.data?.data[0]);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getSession();
  }, [member]);

  const getDuration = () => {
    const dur =
      state?.startTime &&
      state?.endTime &&
      formatDistance(parseISO(state.endTime), parseISO(state.startTime));
  };
  useEffect(() => {
    getProgram();
    getDuration();
  }, []);
  return (
    <div className="row column-gap-5">
      {setViewMode && (
        <div className="d-flex mt-2 justify-content-between">
          <button
            className="btn btn-primary btn-custom-tag py-2 "
            onClick={() => setViewMode("sessionNotes")}
          >
            <IoArrowBack /> &nbsp;&nbsp;&nbsp; Back
          </button>
          <div className="d-flex gap-2 ">
            <button
              className="btn btn-custom text-white py-2"
              onClick={() => setViewMode("sessionGroupNoteEdit")}
            >
              <AiFillEdit /> &nbsp; Edit Note
            </button>
            {/* <PDFDownloadLink
              style={{ textDecoration: "none" }}
              document={
                <SessionNotePDF
                  chartImage1={chartImage}
                  chartImage2={chartImage}
                  chartImage3={chartImage}
                  chartImage4={chartImage}
                  chartImage5={chartImage}
                  session={session}
                />
              }
              fileName={`${member?.full_name}_Session_Note.pdf`}
            >
              {({ loading }) => (
                <button className="btn btn-custom-tag py-2">
                  Download Notes &nbsp;
                  <MdDownloadForOffline color={"#1F7E78"} size={18} />
                </button>
              )}
            </PDFDownloadLink> */}
          </div>
        </div>
      )}
      <div className="mt-4">
        <h5 className="fw-bold"> Group Session Note</h5>
      </div>
      {isLoading ? (
        <center>
          <div
            style={{ width: "3rem", height: "3rem", color: "#1f7e78" }}
            class="spinner-border mt-3 mb-4"
            role="status"
          />
        </center>
      ) : (
        <div>
          <div className="">
            <div className="d-flex gap-2 align-items-center mt-4 justify-content-between">
              <h6 className="text-green mb-0 fw-bold">
                Program Title{" "}
                <span className="text-dark ms-3">
                  {programDetails?.programName}
                </span>
              </h6>
              
              <h6 className="text-green mb-0 fw-bold">
                Facilitator{" "}
                <span className="text-dark ms-3">
                  {session?.session?.createdBy}
                </span>
              </h6>
            </div>
            <div className="d-flex gap-2 align-items-center mt-4 justify-content-between">
              <h6 className="text-green mb-0 fw-bold">
                Encounter type{" "}
                <span className="text-dark ms-3">{session?.session.title}</span>
              </h6>
              <h6 className="text-green mb-0 fw-bold">
                Encounter Date{" "}
                <span className="text-dark ms-3">
                  {moment(session?.session.sessionDate).format("DD MMMM, YYYY")}
                </span>
              </h6>
              <h6 className="text-green mb-0 fw-bold">
                Duration{" "}
                <span className="text-dark ms-3">
                {
                  Math.floor((new Date(session?.session?.endTime) - new Date(session?.session?.startTime)) / 60000)+" minutes"
                }
                </span>
              </h6>
            </div>
            <div className="d-flex gap-2 align-items-center mt-4 justify-content-between">
              <h6 className="text-green mb-0 fw-bold">
                Session Title{" "}
                <span className="text-dark ms-3">{session?.session.title}</span>
              </h6>
              <h6 className="text-green mb-0 fw-bold">
                Number of Participants{" "}
                <span className="text-dark ms-3">
                {programDetails?.programMembers?.length}
                </span>
              </h6>
              
            </div>
          </div>

          <div className="mt-1 pt-2">
            <div className="bg-green px-3 py-2">
              <h6 className="text-white mb-0 fw-bold">Subjective</h6>
            </div>
            <div>
              <div className="d-flex gap-3 mt-3 w-100">
                <h6 className="text-green mb-0 text-nowrap fw-bold">
                  Reported Concerns
                </h6>
                <div className="w-100">
                  {session?.groupSession?.concerns.map((item, index) => (
                    <div
                      className="d-flex gap-4 mb-2 align-items-center justify-content-between"
                      key={index}
                    >
                      <div className="d-flex gap-3 align-items-center">
                        <h6 className=" mb-0 fw-bold">
                          {String.fromCharCode(65 + index)}
                        </h6>
                        <span className="mb-0">{item.concern}</span>
                      </div>
                      <div className="d-flex gap-4 align-items-center">
                        <h6 className="text-green mb-0 pb-0 fw-bold">
                        Number of
                        Members
                        </h6>
                        <span className="mb-0">
                          {item.numberOfMembers }
                        </span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="mt-2 text-center">
                <div className="row mt-3">
                  <div className="col-md-4 px-3 text-center d-flex align-items-center justify-content-end  ">
                    <h6 className="text-green mb-0">% of participants</h6>
                  </div>
                  <div className="col-md-4 px-3 text-center ">
                    <ConcernChart data={session?.groupSession?.concerns} />
                    <h6 className="text-green">Concerns</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
          

          <div className="mt-2">
            <div className="bg-green px-3 py-2">
              <h6 className="text-white mb-0 ">Objective</h6>
            </div>
            <div id="chart-container">
              <h6 className="text-green mb-0 mt-3 fw-bold ">Group Health Metrics</h6>
              <div className="row mt-3 justify-content-center mx-1">
                {session?.groupSession?.healthMetrics?.map((item, index) => (
                  <div className="col-md-4 px-3 mb-4" key={index}>
                    <h6 className=" text-muted mb-0">{item.value}</h6>
                    <div className="d-flex justify-content-between align-items-center">
                      <h6 className="text-green text-center d-block  mt-3">
                        {item.code}
                      </h6>
                    </div>
                    {item.value === "Blood Pressure" ? (
                      <RateChart
                        data={session?.objectives
                          .filter((obj) => obj[item.key].diastolic)
                          .map((obj) => {
                            return {
                              name: obj.name,
                              value: obj[item.key].diastolic,
                              value2: obj[item.key].systolic,
                            };
                          })}
                      />
                    ) : (
                      <RateChart
                        data={session?.objectives
                          .filter((obj) => obj[item.key])
                          .map((obj) => {
                            return { name: obj.name, value: obj[item.key] };
                          })}
                      />
                    )}
                    <h6 className="text-muted text-center d-block  mt-3">Members</h6>
                    {item.value === "Blood Pressure" && (
                      <div className="my-2 text-center ">
                        <div className="d-flex gap-4 align-items-center justify-content-center">
                          <div className="d-flex gap-2 align-items-center">
                            <span
                              style={{
                                width: "20px",
                                height: "8px",
                                backgroundColor: "#4CC2B0",
                                borderRadius: "30%",
                              }}
                            ></span>
                            <span>Systolic</span>
                          </div>
                          <div className="d-flex gap-2 align-items-center">
                            <span
                              style={{
                                width: "20px",
                                height: "8px",
                                backgroundColor: "#999B9C",
                                borderRadius: "30%",
                              }}
                            ></span>
                            <span>Diastolic</span>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                ))}
              </div>
              
            </div>
          </div>
          <div className="mt-2 pt-2">
            <div className="">
              <span className="" style={{ fontWeight: "500" }}>
                Other Comments
              </span>
            </div>
            <div className="mt-2">
              <div
                dangerouslySetInnerHTML={{
                  __html: session?.groupSession?.healthMetricsComments,
                }}
              ></div>
            </div>
          </div>
          <div className="mt-2">
            <div className="bg-green px-3 py-2">
              <h6 className="text-white mb-0 fw-bold">Assessment</h6>
            </div>
            <div className="mt-3 ">
              <span  style={{ fontWeight: "500" }}>Clinical Summary & Key Takeaways</span>
            </div>
            <div className=" pt-2">
              <div className="mt-2">
                <div
                  dangerouslySetInnerHTML={{
                    __html: session?.groupSession?.assessmentComments,
                  }}
                ></div>
              </div>
            </div>
          </div>
          <div className="mt-2">
            <div className="bg-green px-3 py-2">
              <h6 className="text-white mb-0 fw-bold">Plan</h6>
            </div>
            <div className="mt-3">
              {session?.groupSession?.carePlans.map((item, index) => (
                <div
                  className="d-flex gap-3 align-items-center mb-2"
                  key={index}
                >
                  <input
                    type="text"
                    className="form-control bg-light w-25"
                    value={item.name}
                    disabled
                  />
                </div>
              ))}
            </div>

            <div className="py-2">
              <h6 className="text-green mb-0">Goals</h6>
            </div>
            <div className="mt-2 w-100">
              <div className="w-100 row view-sesstion-details-plan-container">
                {session?.groupSession?.carePlans[0]?.goals?.map(
                  (item, index) => (
                    <div className="mb-4" key={index}>
                      <div className="d-flex gap-3 align-items-center mb-2 justify-content-between">
                        <h6 className="mb-0 d-flex gap-2 align-items-center text-nowrap">
                          {index + 1 < 10 ? `0${index + 1}` : index + 1}{" "}
                          &nbsp;&nbsp;&nbsp;&nbsp; {item.goalName}
                        </h6>

                        <h6 className="mb-0 d-flex gap-2 align-items-center text-nowrap text-green">
                          Duration
                          <span className="text-dark">{item.duration}</span>
                          <span className="mb-0 text-black">Days</span>
                        </h6>
                      </div>

                      <div className="w-100 ">
                        <table className="w-100">
                          <thead>
                            <tr>
                              <th>Tasks</th>
                              <th>Frequency</th>
                              <th>Priority</th>
                            </tr>
                          </thead>
                          <tbody>
                            {item.tasks.map((task, index) => (
                              <tr key={index} className="border-bottom">
                                <td>{task.title}</td>
                                <td>{task.frequency}</td>
                                <td>{task.priority}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  )
                )}
              </div>

              <div className="w-100 row mt-4">
                <div className="col-md-6">
                  <table className="w-100">
                    <tbody>
                      <tr>
                        <td colSpan={3} className="text-green ">
                          <div className="d-flex gap-2 align-items-center">
                            <svg
                              width="18"
                              height="18"
                              viewBox="0 0 18 21"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M11.591 0.96534C10.7321 1.081 9.85967 1.48197 9.12928 2.1027C8.75393 2.41885 1.23699 10.9973 0.990147 11.3905C0.587755 12.0267 0.330766 12.6551 0.165075 13.4108C-0.122347 14.7024 -0.0141411 16.0672 0.476168 17.2624C1.51765 19.8186 3.97596 21.1603 6.36326 20.474C7.02264 20.2851 7.57381 19.9921 8.13175 19.5333C8.47666 19.2518 16.0004 10.6811 16.2776 10.2532C16.7138 9.58617 16.9708 8.96544 17.1467 8.17507C17.4341 6.88348 17.3259 5.51865 16.8356 4.32345C15.8989 2.02174 13.799 0.680035 11.591 0.96534ZM13.0687 2.84295C14.3604 3.24778 15.3139 4.35044 15.6419 5.81937C15.7366 6.25119 15.7298 7.33843 15.6284 7.75482C15.5202 8.20976 15.368 8.59146 15.1415 8.98857C14.9656 9.29315 14.6782 9.64014 13.1904 11.3443L11.4489 13.3414L8.93653 10.4768L6.42412 7.61217L7.93901 5.88492C8.77084 4.93262 9.59253 4.0073 9.76837 3.82995C10.2993 3.28248 10.8234 2.96633 11.4625 2.80825C11.848 2.71187 12.7102 2.73114 13.0687 2.84295ZM5.47732 9.25074C5.59229 9.34327 5.65992 9.54761 5.6261 9.69798C5.6092 9.77508 5.18652 10.2879 4.27691 11.3327C3.22866 12.5433 2.92095 12.9173 2.79584 13.1486C2.5287 13.6383 2.42388 14.0045 2.36977 14.6368C2.32582 15.1226 2.22775 15.2653 1.94033 15.2653C1.84565 15.2653 1.79155 15.2344 1.70025 15.1303L1.57852 14.9915L1.59881 14.5597C1.62924 13.8387 1.80507 13.2334 2.17027 12.5973C2.34272 12.3043 2.60309 11.9843 3.61415 10.8161C4.29381 10.0334 4.91262 9.34327 4.98363 9.28544C5.14594 9.1505 5.3353 9.13508 5.47732 9.25074Z"
                                fill="#1F7E78"
                              />
                            </svg>
                            Medication
                          </div>
                        </td>
                      </tr>
                      {session?.groupSession?.carePlans[0]?.medications?.map(
                        (item, index) => (
                          <tr key={index}>
                            <td>{item.medicineName.label}</td>
                            <td>{item.quantity}</td>
                            <td>{item.schedule}</td>
                          </tr>
                        )
                      )}
                    </tbody>
                  </table>
                </div>
                <div className="col-md-6">
                  <table className="w-100">
                    <tbody>
                      <tr>
                        <td colSpan={3} className="text-green">
                          <div className="d-flex gap-2 align-items-center">
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 32 30"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M16.0026 13.4805C18.3959 13.4805 20.3359 11.7223 20.3359 9.55339C20.3359 7.38449 18.3959 5.6263 16.0026 5.6263C13.6093 5.6263 11.6693 7.38449 11.6693 9.55339C11.6693 11.7223 13.6093 13.4805 16.0026 13.4805ZM16.0026 14.6888C19.1322 14.6888 21.6693 12.3896 21.6693 9.55339C21.6693 6.71717 19.1322 4.41797 16.0026 4.41797C12.873 4.41797 10.3359 6.71717 10.3359 9.55339C10.3359 12.3896 12.873 14.6888 16.0026 14.6888Z"
                                fill="#1F7E78"
                              />
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M16.2565 6.77949C16.6234 6.80734 16.896 7.09948 16.8652 7.43195L16.4638 11.7743C16.4331 12.1068 16.1108 12.3538 15.7438 12.3259C15.377 12.2981 15.1044 12.006 15.1352 11.6734L15.5366 7.33112C15.5673 6.99858 15.8896 6.75163 16.2565 6.77949Z"
                                fill="#1F7E78"
                              />
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M9.66667 24.9609C12.0599 24.9609 14 23.2028 14 21.0339C14 18.865 12.0599 17.1068 9.66667 17.1068C7.2734 17.1068 5.33333 18.865 5.33333 21.0339C5.33333 23.2028 7.2734 24.9609 9.66667 24.9609ZM9.66667 26.1693C12.7963 26.1693 15.3333 23.8701 15.3333 21.0339C15.3333 18.1977 12.7963 15.8984 9.66667 15.8984C6.53705 15.8984 4 18.1977 4 21.0339C4 23.8701 6.53705 26.1693 9.66667 26.1693Z"
                                fill="#1F7E78"
                              />
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M11.8349 22.9993C11.5746 23.2353 11.1525 23.2353 10.8921 22.9993L7.49212 19.9181C7.23179 19.6822 7.23179 19.2996 7.49212 19.0637C7.75252 18.8277 8.17459 18.8277 8.43492 19.0637L11.8349 22.1449C12.0953 22.3808 12.0953 22.7634 11.8349 22.9993Z"
                                fill="#1F7E78"
                              />
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M22.3307 23.75C24.724 23.75 26.6641 21.9918 26.6641 19.8229C26.6641 17.654 24.724 15.8958 22.3307 15.8958C19.9375 15.8958 17.9974 17.654 17.9974 19.8229C17.9974 21.9918 19.9375 23.75 22.3307 23.75ZM22.3307 24.9583C25.4603 24.9583 27.9974 22.6591 27.9974 19.8229C27.9974 16.9867 25.4603 14.6875 22.3307 14.6875C19.2011 14.6875 16.6641 16.9867 16.6641 19.8229C16.6641 22.6591 19.2011 24.9583 22.3307 24.9583Z"
                                fill="#1F7E78"
                              />
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M25.1741 18.7648C25.3145 19.0733 25.1522 19.4264 24.8118 19.5536L20.3662 21.2139C20.0257 21.341 19.6361 21.194 19.4958 20.8855C19.3555 20.577 19.5177 20.2238 19.8581 20.0967L24.3037 18.4363C24.6442 18.3092 25.0339 18.4563 25.1741 18.7648Z"
                                fill="#1F7E78"
                              />
                            </svg>
                            Supplements
                          </div>
                        </td>
                      </tr>
                      {session?.groupSession?.carePlans[0]?.supplements?.map(
                        (item, index) => (
                          <tr key={index}>
                            <td>{item.supplementName.label}</td>
                            <td>{item.quantity}</td>
                            <td>{item.schedule}</td>
                          </tr>
                        )
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="w-100 row mt-4">
                <div className="col-md-4">
                  <table className="w-100">
                    <tbody>
                      <tr>
                        <td className="text-green ">
                          <div className="d-flex gap-2 align-items-center">
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 32 30"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M15.5091 7.07584C14.9312 6.80823 14.931 6.80859 14.931 6.80859L14.9303 6.80991L14.9289 6.81254L14.9248 6.82032L14.9114 6.84611C14.9003 6.86772 14.885 6.89806 14.8666 6.93623C14.8296 7.01259 14.7795 7.12078 14.7244 7.25375C14.6146 7.51788 14.481 7.88811 14.391 8.3049C14.2203 9.09552 14.1636 10.2664 15.0522 11.0894C15.4558 11.4632 15.5125 12.0875 15.3601 12.7929C15.2886 13.1242 15.18 13.4271 15.0878 13.6492C15.042 13.7594 15.0012 13.8474 14.9725 13.9067C14.9582 13.9363 14.947 13.9586 14.9398 13.9726L14.9321 13.9873L14.931 13.9894C14.931 13.9894 14.9312 13.9891 15.5091 14.2567C16.087 14.5243 16.0873 14.5236 16.0873 14.5236L16.0879 14.5226L16.0893 14.5201L16.0934 14.5122L16.1068 14.4865C16.1179 14.4649 16.1332 14.4345 16.1516 14.3963C16.1886 14.3199 16.2387 14.2118 16.2938 14.0788C16.4035 13.8147 16.5372 13.4444 16.6272 13.0276C16.7979 12.237 16.8546 11.0662 15.9659 10.2431C15.5624 9.86937 15.5057 9.245 15.6581 8.5396C15.7296 8.20838 15.8382 7.90541 15.9304 7.68334C15.9762 7.57317 16.017 7.48509 16.0457 7.42579C16.06 7.39623 16.0712 7.37397 16.0784 7.35996L16.0861 7.34518L16.0872 7.34315C16.0872 7.34315 16.087 7.34345 15.5091 7.07584Z"
                                fill="#1F7E78"
                              />
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M2.58594 18.1453C2.58594 17.8148 2.87521 17.5469 3.23203 17.5469H27.7835C28.1403 17.5469 28.4296 17.8148 28.4296 18.1453C28.4296 18.4758 28.1403 18.7437 27.7835 18.7437H25.8452C25.8452 21.3876 23.5311 23.5309 20.6765 23.5309H10.339C7.4844 23.5309 5.1703 21.3876 5.1703 18.7437H3.23203C2.87521 18.7437 2.58594 18.4758 2.58594 18.1453ZM6.46248 18.7437H24.553C24.553 20.7266 22.8174 22.3341 20.6765 22.3341H10.339C8.19807 22.3341 6.46248 20.7266 6.46248 18.7437Z"
                                fill="#1F7E78"
                              />
                              <path
                                d="M9.80189 8.23828C9.80189 8.23828 9.80221 8.23792 10.3377 8.57273C10.8732 8.90754 10.8734 8.90724 10.8734 8.90724L10.8655 8.91861C10.8581 8.92932 10.8462 8.94679 10.8308 8.97019C10.8001 9.01722 10.756 9.08766 10.7067 9.17574C10.6065 9.35454 10.4913 9.59367 10.4163 9.85074C10.2607 10.3846 10.3166 10.8056 10.7222 11.0839C11.7703 11.803 11.7144 12.878 11.5066 13.5908C11.3998 13.9571 11.2424 14.2789 11.1155 14.5052C11.0514 14.6198 10.9931 14.713 10.9501 14.779C10.9285 14.812 10.9106 14.8384 10.8974 14.8574L10.884 14.8765L10.8814 14.8802L10.8762 14.8874L10.8745 14.8898L10.8738 14.8908C10.8738 14.8908 10.8732 14.8916 10.3377 14.5568C9.80221 14.222 9.80195 14.2223 9.80195 14.2223L9.8099 14.2109C9.81733 14.2002 9.82922 14.1828 9.84459 14.1593C9.87528 14.1123 9.91934 14.0419 9.96871 13.9538C10.0689 13.775 10.1841 13.5358 10.2591 13.2788C10.4147 12.7449 10.3588 12.3239 9.95314 12.0456C8.90505 11.3265 8.961 10.2515 9.16878 9.53873C9.27558 9.17251 9.43297 8.85063 9.55986 8.62425C9.62402 8.50978 9.68223 8.41655 9.72532 8.35054C9.7469 8.31751 9.7648 8.29112 9.77798 8.27215C9.78457 8.2627 9.78993 8.25504 9.794 8.24929L9.79917 8.24211L9.80092 8.23966L9.80189 8.23828Z"
                                fill="#1F7E78"
                              />
                              <path
                                d="M21.3221 8.57273C20.7866 8.23792 20.7863 8.23828 20.7863 8.23828L20.7853 8.23966L20.7835 8.24211L20.7784 8.24929C20.7743 8.25504 20.7689 8.2627 20.7624 8.27215C20.7492 8.29112 20.7313 8.31751 20.7097 8.35054C20.6666 8.41655 20.6084 8.50978 20.5442 8.62425C20.4173 8.85063 20.26 9.17251 20.1532 9.53873C19.9454 10.2515 19.8894 11.3265 20.9375 12.0456C21.3431 12.3239 21.3991 12.7449 21.2434 13.2788C21.1685 13.5358 21.0533 13.775 20.9531 13.9538C20.9037 14.0419 20.8597 14.1123 20.8289 14.1593C20.8136 14.1828 20.8017 14.2002 20.7943 14.2109L20.7863 14.2223C20.7863 14.2223 20.7866 14.222 21.3221 14.5568C21.8575 14.8916 21.8581 14.8908 21.8581 14.8908L21.8588 14.8898L21.8606 14.8874L21.8657 14.8802L21.876 14.8657L21.8818 14.8574C21.895 14.8384 21.9128 14.812 21.9344 14.779C21.9775 14.713 22.0357 14.6198 22.0999 14.5052C22.2268 14.2789 22.3842 13.9571 22.491 13.5908C22.6988 12.878 22.7547 11.803 21.7066 11.0839C21.301 10.8056 21.245 10.3846 21.4007 9.85074C21.4756 9.59367 21.5908 9.35454 21.691 9.17574C21.7404 9.08766 21.7845 9.01722 21.8152 8.97019C21.8305 8.94679 21.8424 8.92932 21.8499 8.91861L21.8578 8.90724C21.8578 8.90724 21.8575 8.90754 21.3221 8.57273Z"
                                fill="#1F7E78"
                              />
                            </svg>
                            Meal plan
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          {
                            session?.groupSession?.carePlans[0]?.mealPlan
                              ?.planName
                          }
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className="col-md-4">
                  <table className="w-100">
                    <tbody>
                      <tr>
                        <td colSpan={3} className="text-green">
                          <div className="d-flex gap-2 align-items-center">
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 30 33"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M26.2254 5.72601L25.6197 5.62214L25.4608 4.98297L26.3738 4.71875L26.2254 5.72601ZM18.1167 14.8785C17.5944 15.2255 17.5943 15.2253 17.5942 15.2251L17.5934 15.2238L17.5916 15.2206L17.5857 15.2101L17.5648 15.1725C17.547 15.1402 17.5218 15.094 17.4907 15.0352C17.4283 14.9178 17.3417 14.7498 17.2426 14.5435C17.0451 14.1328 16.7934 13.5622 16.5838 12.932C16.3761 12.3074 16.1986 11.592 16.1711 10.8997C16.1437 10.2102 16.2634 9.4617 16.7386 8.87551C17.1663 8.34782 17.9724 7.86334 18.8191 7.44319C19.6972 7.00742 20.7299 6.58921 21.7083 6.22708C22.6889 5.86413 23.6261 5.55343 24.3173 5.33367C24.6632 5.2237 24.9482 5.13628 25.1471 5.07625C25.2465 5.04622 25.3245 5.02304 25.3778 5.0073L25.439 4.98933L25.4608 4.98297C25.4609 4.98294 25.4608 4.98297 25.6197 5.62214C26.2254 5.72601 26.2255 5.72591 26.2254 5.72601L26.2218 5.75071L26.2113 5.82067C26.2021 5.88179 26.1885 5.97127 26.1708 6.08543C26.1355 6.31371 26.0839 6.64081 26.0187 7.03724C25.8883 7.82959 25.7031 8.90132 25.4843 10.0157C25.2658 11.1278 25.0117 12.2934 24.7427 13.2696C24.6083 13.7572 24.4672 14.2084 24.3213 14.5869C24.1813 14.9503 24.0156 15.3043 23.8146 15.5523C23.3838 16.0838 22.7132 16.2498 22.128 16.292C21.5168 16.3362 20.8403 16.2559 20.2307 16.1403C19.6155 16.0236 19.0391 15.865 18.6186 15.7366C18.4077 15.6722 18.2343 15.6148 18.1128 15.5733C18.0521 15.5525 18.0043 15.5357 17.9712 15.5239L17.9326 15.51L17.922 15.5061L17.919 15.505L17.918 15.5046C17.9179 15.5046 17.9175 15.5044 18.1167 14.8785ZM18.1167 14.8785L17.5942 15.2251L17.7096 15.4274L17.918 15.5046L18.1167 14.8785ZM18.5285 14.3269C18.6363 14.3633 18.7809 14.4106 18.9527 14.4631C19.3483 14.5839 19.8819 14.7303 20.4431 14.8368C21.0099 14.9443 21.5762 15.0054 22.0462 14.9714C22.5422 14.9356 22.7914 14.8041 22.8912 14.681C22.9555 14.6018 23.0596 14.4137 23.1886 14.0788C23.3118 13.7591 23.439 13.3561 23.5669 12.8923C23.8223 11.9655 24.0686 10.8392 24.2842 9.7413C24.4994 8.64575 24.6819 7.58924 24.8108 6.80592C24.8259 6.71449 24.8402 6.6268 24.8537 6.54325C24.7928 6.56239 24.7296 6.58239 24.6641 6.60322C23.9839 6.81947 23.0649 7.12423 22.1064 7.47899C21.1457 7.83456 20.1565 8.23631 19.3316 8.64568C18.4752 9.0706 17.8974 9.45634 17.662 9.74679C17.4739 9.97874 17.3765 10.3353 17.3967 10.8431C17.4167 11.3481 17.5512 11.9222 17.7384 12.485C17.9237 13.042 18.1498 13.5564 18.3314 13.934C18.4081 14.0933 18.476 14.2267 18.5285 14.3269ZM6.79585 7.39217L6.63693 8.03137L6.03118 8.1352L5.88281 7.12795L6.79585 7.39217ZM12.734 15.5532C13.2563 15.9001 13.2564 15.9 13.2564 15.8998L13.2572 15.8986L13.2588 15.8958L13.2638 15.8868L13.2812 15.8555C13.296 15.8287 13.3168 15.7906 13.3425 15.7422C13.3938 15.6454 13.4649 15.5074 13.5463 15.3381C13.7084 15.0013 13.9152 14.5323 14.0878 14.0133C14.2585 13.5 14.4068 12.9053 14.4298 12.3252C14.4527 11.7479 14.3534 11.103 13.9404 10.5935C13.5748 10.1424 12.8983 9.73945 12.2113 9.3985C11.4927 9.04188 10.6494 8.70054 9.85268 8.40559C9.05373 8.10992 8.29053 7.85692 7.72778 7.67798C7.44613 7.58845 7.21404 7.51724 7.05193 7.46834C6.9709 7.44385 6.90736 7.42492 6.86381 7.41209L6.81382 7.39742L6.79585 7.39217C6.79573 7.39215 6.79585 7.39217 6.63693 8.03137C6.03118 8.1352 6.03117 8.13513 6.03118 8.1352L6.03419 8.15551L6.04276 8.21256C6.05027 8.26239 6.06135 8.33531 6.07574 8.42823C6.10451 8.61411 6.14651 8.88034 6.19958 9.20295C6.30565 9.84764 6.45636 10.72 6.63454 11.6273C6.81235 12.5324 7.01954 13.4832 7.23949 14.2811C7.34928 14.6795 7.4652 15.0507 7.58591 15.3638C7.70067 15.6618 7.84107 15.9651 8.01728 16.1824C8.39836 16.6525 8.9827 16.7906 9.46658 16.8256C9.97658 16.8624 10.5366 16.7954 11.036 16.7007C11.541 16.6049 12.0134 16.4748 12.3574 16.3698C12.5302 16.3171 12.6722 16.2701 12.7718 16.236C12.8217 16.219 12.861 16.2051 12.8884 16.1954L12.9203 16.1838L12.9292 16.1806L12.9327 16.1793C12.9328 16.1793 12.9332 16.1791 12.734 15.5532ZM12.734 15.5532L13.2564 15.8998L13.1411 16.102L12.9327 16.1793L12.734 15.5532ZM12.3216 15.0012C12.3599 14.927 12.4063 14.835 12.4575 14.7285C12.6035 14.4249 12.7849 14.0121 12.9332 13.5662C13.0834 13.1148 13.1887 12.6615 13.2042 12.2686C13.2199 11.873 13.1429 11.62 13.017 11.4647C12.8437 11.251 12.3955 10.9468 11.6987 10.6009C11.0334 10.2708 10.2336 9.94585 9.45462 9.65752C8.68885 9.37409 7.95393 9.12996 7.40467 8.95506C7.40559 8.96055 7.40651 8.96611 7.40743 8.9716C7.512 9.60736 7.66013 10.4644 7.83463 11.353C8.00962 12.2438 8.20896 13.1553 8.41529 13.9038C8.51858 14.2785 8.62064 14.6015 8.71859 14.8557C8.82243 15.1252 8.90125 15.2625 8.94063 15.3111C8.99068 15.3728 9.15377 15.4765 9.54852 15.505C9.91721 15.5316 10.367 15.4838 10.8236 15.3971C11.2746 15.3116 11.7043 15.1937 12.0233 15.0963C12.1399 15.0607 12.2408 15.0281 12.3216 15.0012ZM10.9781 21.3105C10.8226 21.3201 10.7462 21.344 10.7273 21.3532C10.4492 21.4888 9.60507 21.8062 8.87647 22.0746C8.50214 22.2125 8.14333 22.3428 7.87824 22.4386C7.87253 22.4407 7.86683 22.4428 7.86119 22.4448V26.0202C7.96907 26.0156 8.08481 26.0108 8.20362 26.0061C8.71136 25.9862 9.31575 25.9668 9.57753 25.9781C10.6768 26.0255 11.5019 26.3061 12.2664 26.5661L12.2826 26.5717C12.9991 26.8154 13.6627 27.0392 14.5321 27.1097C14.7777 27.1296 15.0157 27.1552 15.2384 27.1791L15.2414 27.1795C16.0969 27.2714 16.6598 27.3184 17.0956 27.1476C17.4353 27.0145 18.6769 26.3934 19.9296 25.7136C20.5488 25.3775 21.1561 25.035 21.6392 24.7418C21.8812 24.5949 22.0865 24.4638 22.2442 24.3543C22.3231 24.2996 22.386 24.2531 22.4336 24.2152C22.4571 24.1963 22.475 24.1811 22.488 24.1694C22.5015 24.1572 22.5064 24.1518 22.5054 24.1529C22.5664 24.086 22.6317 23.8536 22.5266 23.6342C22.4843 23.5458 22.4142 23.4644 22.2956 23.4091C22.1728 23.3519 21.9641 23.3076 21.6326 23.3663C20.8855 23.4985 19.9935 23.8864 19.1024 24.2776L19.0894 24.2832C18.6517 24.4754 18.2126 24.6682 17.8233 24.8082C17.4493 24.9427 17.0337 25.0628 16.6721 25.0394C16.175 25.0073 15.3034 24.8675 14.5848 24.7422C14.2192 24.6785 13.883 24.6166 13.6383 24.5708C13.5159 24.5479 13.4162 24.5289 13.347 24.5157L13.2671 24.5002L13.2391 24.4948L13.3551 23.1818L16.1591 23.2181C16.1604 23.218 16.1622 23.2178 16.1645 23.2176C16.1789 23.2162 16.2123 23.2118 16.2616 23.1982C16.3587 23.1712 16.5247 23.1062 16.7337 22.9465C16.7985 22.897 16.8831 22.8057 16.9619 22.683C16.9946 22.6322 17.0225 22.5818 17.0456 22.5341C16.6678 22.511 16.3062 22.443 16.0301 22.3786C15.858 22.3383 15.713 22.2981 15.6102 22.2676C15.5587 22.2523 15.5174 22.2394 15.4882 22.2301C15.4804 22.2275 15.4734 22.2252 15.4673 22.2232L12.0343 21.3991C12.0272 21.3978 12.0163 21.3958 12.0019 21.3932C11.9723 21.3878 11.9283 21.3803 11.8736 21.3717C11.7634 21.3546 11.6132 21.3342 11.4508 21.3208C11.2866 21.3072 11.1214 21.3017 10.9781 21.3105ZM12.1551 20.7502L12.2666 20.0995L12.2775 20.1016L15.7843 20.9435L15.8103 20.9523L15.8151 20.954L15.8385 20.9616C15.8599 20.9685 15.8928 20.9788 15.9353 20.9914C16.0205 21.0166 16.1432 21.0508 16.2895 21.0849C16.5876 21.1546 16.96 21.2187 17.305 21.2187C17.6504 21.2187 18.0256 21.3572 18.2279 21.7537C18.4009 22.0925 18.3582 22.459 18.2975 22.7008C18.2465 22.9035 18.1595 23.1124 18.0476 23.3089C18.2343 23.2297 18.432 23.143 18.64 23.0517L18.6784 23.0348C19.5232 22.664 20.5364 22.2191 21.434 22.0602C22.4765 21.8757 23.2587 22.2795 23.6165 23.0267C23.9316 23.6847 23.8613 24.5528 23.3801 25.0808C23.2596 25.213 23.0802 25.3478 22.9078 25.4675C22.7217 25.5966 22.4933 25.742 22.2407 25.8954C21.7345 26.2026 21.1085 26.5553 20.4808 26.896C19.2399 27.5694 17.9337 28.2273 17.5144 28.3916C16.7868 28.6768 15.9452 28.5857 15.1974 28.5048C15.1714 28.5021 15.1455 28.4992 15.1197 28.4965C14.894 28.4722 14.6696 28.4481 14.4401 28.4295C13.422 28.3469 12.6415 28.0815 11.9287 27.839L11.9138 27.834C11.1466 27.573 10.4562 27.3405 9.52859 27.3006C9.32496 27.2918 8.77674 27.308 8.24821 27.3288C7.99079 27.3389 7.74759 27.3496 7.56862 27.3579C7.47919 27.362 7.40595 27.3654 7.35505 27.3679L7.27629 27.3717L6.63448 27.4035V21.4902L7.17263 21.2976C7.2482 21.2704 7.35676 21.2313 7.48857 21.1837C7.75225 21.0884 8.10867 20.9589 8.48006 20.8221C9.24289 20.541 10.0122 20.2495 10.222 20.1472C10.447 20.0374 10.7026 20.0018 10.9079 19.9891C11.1255 19.9757 11.3498 19.985 11.5447 20.0012C11.7416 20.0174 11.92 20.0417 12.0487 20.0618C12.1134 20.0718 12.1664 20.081 12.2039 20.0877C12.2226 20.0911 12.2375 20.0939 12.2481 20.0959L12.2608 20.0983L12.2646 20.099L12.2658 20.0993L12.2666 20.0995C12.2667 20.0995 12.2666 20.0995 12.1551 20.7502Z"
                                fill="#1F7E78"
                              />
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M22.0621 9.55386C22.3193 9.7917 22.3491 10.2095 22.1287 10.487C20.3007 12.788 18.0247 16.1611 17.0198 18.9026C16.8952 19.2425 16.5389 19.4091 16.2239 19.2747C15.9089 19.1403 15.7545 18.7558 15.8791 18.4159C16.9606 15.4651 19.3451 11.9571 21.1972 9.62566C21.4177 9.34812 21.8049 9.31602 22.0621 9.55386Z"
                                fill="#1F7E78"
                              />
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M9.93676 11.6773C9.67075 11.9035 9.62512 12.3196 9.83482 12.6066C11.2104 14.4892 12.7113 16.8992 13.4242 18.8977C13.5459 19.2388 13.9008 19.4088 14.2169 19.2776C14.5331 19.1463 14.6907 18.7634 14.5691 18.4223C13.789 16.2356 12.1963 13.7007 10.7982 11.7872C10.5885 11.5002 10.2028 11.451 9.93676 11.6773Z"
                                fill="#1F7E78"
                              />
                              <path
                                d="M4.17969 19.9844H7.85981V28.5873H4.17969V19.9844Z"
                                fill="#1F7E78"
                              />
                            </svg>
                            Affirmations
                          </div>
                        </td>
                      </tr>
                      {session?.groupSession?.carePlans[0]?.affirmations?.map(
                        (item, index) => (
                          <tr key={index}>
                            <td>{item}</td>
                          </tr>
                        )
                      )}
                    </tbody>
                  </table>
                </div>
                <div className="col-md-4">
                  <table className="w-100">
                    <tbody>
                      <tr>
                        <td colSpan={3} className="text-green">
                          <div className="d-flex gap-2 align-items-center">
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 30 32"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M11.6111 20.7595C11.8219 20.7027 12.0465 20.7616 12.2039 20.9149L14.2343 22.8929C14.403 23.0573 14.4673 23.3036 14.4008 23.5313L13.9575 25.0507C13.8469 25.43 13.6227 25.7648 13.3161 26.0088L10.4141 28.3176C9.59895 28.9662 8.42044 28.8208 7.78188 27.9929C7.14326 27.1649 7.28644 25.9679 8.10163 25.3193L10.5322 23.3855L11.172 21.1927C11.2339 20.9804 11.4004 20.8162 11.6111 20.7595ZM12.079 22.5524L11.674 23.9405C11.6371 24.067 11.5624 24.1786 11.4601 24.2599L8.87245 26.3187C8.60076 26.535 8.55301 26.9339 8.76588 27.2099C8.97876 27.4859 9.37157 27.5344 9.64332 27.3182L12.5453 25.0093C12.6474 24.928 12.7222 24.8164 12.7591 24.69L13.0942 23.5414L12.079 22.5524Z"
                                fill="#1F7E78"
                              />
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M17.5 8.41031C18.5356 8.41031 19.375 7.55773 19.375 6.50596C19.375 5.45421 18.5356 4.6016 17.5 4.6016C16.4645 4.6016 15.625 5.45421 15.625 6.50596C15.625 7.55773 16.4645 8.41031 17.5 8.41031ZM17.5 9.67988C19.2259 9.67988 20.625 8.25885 20.625 6.50596C20.625 4.75305 19.2259 3.33203 17.5 3.33203C15.7741 3.33203 14.375 4.75305 14.375 6.50596C14.375 8.25885 15.7741 9.67988 17.5 9.67988Z"
                                fill="#1F7E78"
                              />
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M13.5831 9.91091C14.4756 9.57403 15.4343 9.59383 16.2951 10.0459C17.114 10.4759 17.6685 11.2029 18.0173 11.9637C18.1479 12.2484 18.2685 12.5142 18.3813 12.7627C18.6561 13.3682 18.8818 13.8652 19.0971 14.2996C19.4011 14.9131 19.6234 15.2726 19.8196 15.5048C19.9879 15.7039 20.1329 15.8049 20.3186 15.8786C20.5381 15.9657 20.8961 16.0453 21.5328 16.0647C22.4968 16.0941 23.2549 16.9116 23.226 17.8908C23.1971 18.8699 22.3921 19.6399 21.4281 19.6105C20.58 19.5847 19.7818 19.4741 19.048 19.183C18.2801 18.8783 17.6745 18.4131 17.1693 17.8153C17.1094 17.7444 17.0511 17.6719 16.9944 17.598L16.7428 18.9334L19.4723 21.6688C19.6461 21.843 19.7821 22.0524 19.8713 22.2833L21.424 26.3012C21.7763 27.2131 21.3342 28.2424 20.4364 28.6004C19.5385 28.9583 18.5251 28.5092 18.1727 27.5973L16.7553 23.9296L11.8435 19.0071C11.4621 18.6249 11.2745 18.0859 11.3348 17.5451L11.5378 15.7229C10.9803 16.4554 10.5112 17.3356 10.184 18.3769C9.89077 19.3102 8.90814 19.8252 7.98933 19.5274C7.07052 19.2296 6.56333 18.2315 6.85658 17.2983C7.96133 13.7828 10.4605 11.1353 13.5625 9.91884L13.5661 9.91738L13.5831 9.91091ZM14.0203 11.1002L14.0109 11.1039C11.2717 12.1787 9.03977 14.5265 8.04745 17.6844C7.96408 17.9496 8.1082 18.2333 8.36939 18.3179C8.63052 18.4026 8.90983 18.2562 8.9932 17.9909C9.61427 16.0145 10.6963 14.5196 11.9683 13.4644C12.1652 13.3012 12.4398 13.2752 12.663 13.3988C12.8861 13.5224 13.0133 13.771 12.9847 14.0275L12.5769 17.6878C12.5597 17.8415 12.613 17.9948 12.7215 18.1034L17.7277 23.1205C17.7899 23.1829 17.8386 23.2578 17.8705 23.3404L19.3363 27.1335C19.4364 27.3926 19.7245 27.5203 19.9796 27.4185C20.2349 27.3168 20.3605 27.0243 20.2604 26.7651L18.7077 22.7472C18.6823 22.6815 18.6437 22.622 18.5943 22.5725L15.6273 19.599C15.4788 19.4502 15.4132 19.236 15.4524 19.0279L16.0653 15.774C16.1153 15.5089 16.3247 15.305 16.5875 15.2654C16.8503 15.2258 17.109 15.3593 17.2326 15.5982C17.5138 16.1422 17.7957 16.6073 18.1178 16.9884C18.5025 17.4436 18.9433 17.7785 19.5027 18.0004C20.0526 18.2185 20.6933 18.3181 21.4655 18.3415C21.7395 18.3499 21.9683 18.1311 21.9766 17.8528C21.9848 17.5745 21.7693 17.3421 21.4953 17.3337C20.7831 17.3121 20.2676 17.2213 19.8639 17.0612C19.47 16.9049 19.1601 16.6737 18.8711 16.3318C18.5741 15.9803 18.2975 15.5101 17.9805 14.8702C17.7546 14.4144 17.5205 13.8988 17.2498 13.3023L17.2463 13.2946C17.1334 13.0458 17.0136 12.7819 16.8842 12.4997C16.6156 11.9138 16.2271 11.4393 15.721 11.1736C15.2036 10.9019 14.6151 10.8762 14.0203 11.1002Z"
                                fill="#1F7E78"
                              />
                            </svg>
                            Fitness plan
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          {
                            session?.groupSession?.carePlans[0]?.fitnessPlan
                              ?.planName
                          }
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div className="mt-3">
              <span style={{fontWeight:"500"}}>Other Comments</span>
              <div className="mt-2">
                <div
                  dangerouslySetInnerHTML={{
                    __html: session?.groupSession?.carePlanComments,
                  }}
                ></div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default ViewSessionGroupNoteDetails;
